import { Routes } from '@angular/router';
import { UnauthorizedComponent } from './core/unauthorized/unauthorized.component';
import { NotFoundComponent } from './core/not-found/not-found.component';
import { authGuard } from './guards/auth.guard';
import { viewGuard } from './guards/view.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/loginhome', pathMatch: 'full' },
  {
    path: 'auth',

    loadChildren: () => import('./templates/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: 'main',
    canActivate: [viewGuard],
    data: { preload: true }, // download the portal shell while the user is on login
    loadChildren: () => import('./templates/views/views.routes').then(m => m.viewsRoutes),
  },
  { path: 'unauthorized', component: UnauthorizedComponent, title: 'Unauthorized' },
  // Keep last: any unknown URL
  { path: '**', component: NotFoundComponent, title: 'Page not found' },
];


